import * as Yup from 'yup'
const schema = Yup.object().shape({
    enable_clara_concierge: Yup.boolean().required()
})
export default schema